import VueModal from "./VueModal.vue";

export default {
  install: (app) => {
    app.component("vue-modal", VueModal);
  },
};
